module.exports = __webpack_public_path__ + "img/hot.de0e9214.png";